<template>
    <SideModal 
        :sides="navs"
        @fechou="handleFechou"
    >
        <!-- Slot para exibir detalhes da ação -->
        <template #detalhes>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Status:</strong> {{ detalhesData.status }}</p>
                        <p><strong>Responsável:</strong> {{ detalhesData.nome_responsavel }}</p>

                        <p><strong>Previsão de Início:</strong> {{ detalhesData.data_estimada_inicio || 'Não definido' }}</p>
                        <p v-if="detalhesData.data_inicio"><strong>Início:</strong> {{ detalhesData.data_inicio }}</p>

                        <p><strong>Previsão de Conclusão:</strong> {{ detalhesData.data_estimada_conclusao || 'Não definida' }}</p>
                        <p v-if="detalhesData.data_conclusao"><strong>Conclusão:</strong> {{ detalhesData.data_conclusao }}</p>

                        <p v-if="detalhesData.justificativa_criacao">
                            <strong>Justificativa de Criação:</strong> {{ detalhesData.justificativa_criacao }}
                        </p>
                        <p v-if="detalhesData.justificativa_rejeicao">
                            <strong>Justificativa de Cancelamento:</strong> {{ detalhesData.justificativa_rejeicao }}
                        </p>
                    </div>
                    <div v-if="detalhesData.compromisso" class="col-xs-12">
                        <h4>Compromisso Relacionado</h4>
                        <p><strong>Descrição:</strong> {{ detalhesData.compromisso && detalhesData.compromisso.descritivo }}</p>
                        <p><strong>Período:</strong> {{ detalhesData.compromisso && detalhesData.compromisso.periodo }}</p>
                        <p><strong>Status:</strong> {{ detalhesData.compromisso && detalhesData.compromisso.status }}</p>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button class="btn btn-default" @click="$emit('fechaModal', 'detalhes')">Fechar</button>
                    </div>
                </div>
            </div>
        </template>

        <!-- Slot para concluir a ação -->
        <template #concluir>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Status Atual:</strong> {{ concluirData.status }}</p>
                        <p><strong>Responsável:</strong> {{ concluirData.nome_responsavel }}</p>
                        <p><strong>Início:</strong> {{ concluirData.data_inicio || 'Não definido' }}</p>
                        <p><strong>Previsão de Conclusão:</strong> {{ concluirData.data_estimada_conclusao || 'Não definida' }}</p>
                        <p v-if="concluirData.justificativa_rejeicao">
                            <strong>Justificativa:</strong> {{ concluirData.justificativa_rejeicao }}
                        </p>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button class="btn btn-success" @click="$emit('concluir', concluirData.id)">Concluir</button>
                        <button class="btn btn-default" @click="$emit('fechaModal', 'concluir')">Cancelar</button>
                    </div>
                </div>
            </div>
        </template>

        <!-- Slot para iniciar a ação -->
         <template #iniciar>
            <div class="side-body">
                <div class="row">
                    <div class="col-xs-12">
                        <p><strong>Status Atual:</strong> {{ iniciarData.status }}</p>
                        <p><strong>Responsável:</strong> {{ iniciarData.nome_responsavel }}</p>
                        <p><strong>Previsão de Início:</strong> {{ iniciarData.data_estimada_inicio || 'Não definido' }}</p>
                        <p><strong>Previsão de Conclusão:</strong> {{ iniciarData.data_estimada_conclusao || 'Não definida' }}</p>
                        <p v-if="iniciarData.justificativa_rejeicao">
                            <strong>Justificativa:</strong> {{ iniciarData.justificativa_rejeicao }}
                        </p>
                    </div>
                    <div class="col-xs-12 slide-footer">
                        <button class="btn btn-success" @click="$emit('iniciar', iniciarData.id)">Iniciar</button>
                        <button class="btn btn-default" @click="$emit('fechaModal', 'iniciar')">Cancelar</button>
                    </div>
                </div>
            </div>
         </template>
    </SideModal>
</template>

<script>
import { SideModal } from '../common'

export default {
    name: 'SideAcao',
    components: { SideModal },
    props: {
        navs: {
            type: Array,
            required: true
        }
    },
    computed: {
        detalhesData() {
            const detalhesNav = this.navs.find(n => n.identidade === 'detalhes')
            return (detalhesNav && detalhesNav.data) ? detalhesNav.data : {}
        },
        concluirData() {
            const concluirNav = this.navs.find(n => n.identidade === 'concluir')
            return (concluirNav && concluirNav.data) ? concluirNav.data : {}
        },
        iniciarData() {
            const iniciarNav = this.navs.find(n => n.identidade === 'iniciar')
            return (iniciarNav && iniciarNav.data) ? iniciarNav.data : {}
        }
    },
    methods: {
        abreModal(nome) {
            this.$refs.sideModal.abreModal(nome)
        },
        fechaModal(nome) {
            this.$refs.sideModal.fechaModal(nome)
        },
        handleFechou({ identidade }) {
            const nav = this.navs.find(n => n.identidade === identidade)
            if (nav) {
                nav.aberto = false
            }
        }
    }
}
</script>

<style scoped>
.side-body {
    padding: 20px;
    font-size: 1.6rem;
}

.side-body p {
    margin-bottom: 12px;
}

.slide-footer {
    margin-top: 20px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

h3,
h4 {
    margin-top: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/planogoverno/SideAcao.vue